module.exports = __webpack_public_path__ + "static/media/practice.d4ffca91.svg";